/* ========================================
   Accordionは1つだけ開く制御
======================================== */
document.addEventListener(
  'toggle',
  function (e) {
    const details = e.target;

    if (
      details.tagName !== 'DETAILS' ||
      !details.closest('accordion-disclosure') ||
      !details.open
    ) {
      return;
    }

    document
      .querySelectorAll('accordion-disclosure details[open]')
      .forEach(function (openDetails) {
        if (openDetails === details) {
          return;
        }

        const summary = openDetails.querySelector('summary');
        if (summary) {
          summary.click();
        }
      });
  },
  true
);

/* ========================================
   Message card UI制御 + hidden property 同期
======================================== */
document.addEventListener('DOMContentLoaded', function () {
  const dropdownName = 'properties[メッセージカードのご希望]';
  const textName = 'properties[印字するメッセージ]';
  const codeName = 'properties[_message_card_code]';

  function getForm() {
    return document.querySelector('form[action*="/cart/add"]');
  }

  function getVariantInput() {
    return getForm()?.querySelector('input[name="id"]');
  }

  function isRequireVariant() {
    const variantInput = getVariantInput();
    if (!variantInput) return false;
    const variantId = parseInt(variantInput.value, 10);
    return window.variantRequireMessage?.[variantId] === true;
  }

  function getDropdown() {
    return document.querySelector('[name="' + dropdownName + '"]');
  }

  function getTextInput() {
    return document.querySelector('[name="' + textName + '"]');
  }

  function getCodeInput() {
    return document.querySelector('[name="' + codeName + '"]');
  }

  function getDropdownBlock() {
    return getDropdown()?.closest('.line-item-property');
  }

  function getTextBlock() {
    return getTextInput()?.closest('.line-item-property');
  }

  const isMobile = window.matchMedia('(max-width: 768px)').matches;

  function showWithFade(block, input) {
    block.style.display = '';
    block.classList.add('message-fade');

    requestAnimationFrame(() => {
      block.classList.add('is-visible');
    });

    if (!isMobile) {
      setTimeout(() => {
        input.focus();
      }, 220);
    }
  }

  function hideWithFade(block) {
    block.classList.remove('is-visible');
    const duration =
      parseFloat(getComputedStyle(block).getPropertyValue('--transition-duration')) || 0.3;

    setTimeout(() => {
      block.style.display = 'none';
    }, duration * 1000);
  }

  function syncMessageCardCode() {
    const dropdown = getDropdown();
    const codeInput = getCodeInput();
    if (!dropdown || !codeInput) return;

    switch (dropdown.value) {
      case 'ご不要':
        codeInput.value = 'none';
        break;
      case '無地メッセージカード':
        codeInput.value = 'blank_card';
        break;
      case '印字メッセージカード':
        codeInput.value = 'printed_card';
        break;
      default:
        codeInput.value = '';
        break;
    }
  }

  function resetMessageCardCode() {
    const codeInput = getCodeInput();
    if (codeInput) codeInput.value = '';
  }

  function clearMessageValidation() {
    const textInput = getTextInput();
    if (textInput) {
      textInput.setCustomValidity('');
    }
  }

  // 許可する文字:
  // - 日本語（ひらがな、カタカナ、漢字）
  // - 英数字
  // - 半角/全角スペース
  // - 一般的な句読点や記号
  // それ以外（絵文字・装飾記号など）はエラー
  function hasInvalidMessageCharacters(value) {
    if (!value) return false;

    const allowedPattern =
      /^[A-Za-z0-9\u3040-\u309F\u30A0-\u30FF\u4E00-\u9FFF\u3005\u3006\u3007\s　.,，、。!！?？\-ー―‐〜～・「」『』（）()【】［］\[\]：:；;／\/＆&＋+＊*％%＃#＠@'"’‘“”]+$/u;

    return !allowedPattern.test(value);
  }

  function validateMessageOnSubmit() {
    const require = isRequireVariant();
    const dropdown = getDropdown();
    const textInput = getTextInput();

    if (!dropdown || !textInput) return true;

    // 前回エラーをクリア
    textInput.setCustomValidity('');

    // 対象外なら検証しない
    if (!require) return true;
    if (dropdown.value !== '印字メッセージカード') return true;
    if (textInput.disabled) return true;

    const value = textInput.value.trim();

    // 必須チェックはブラウザ標準に任せる
    if (!value) return true;

    if (hasInvalidMessageCharacters(value)) {
      textInput.setCustomValidity(
        '絵文字・特殊文字はお使いいただけません。日本語、英数字・記号をお使いください。'
      );
      return false;
    }

    return true;
  }

  function updateVisibility() {
    const require = isRequireVariant();
    const dropdown = getDropdown();
    const textInput = getTextInput();
    const dropdownBlock = getDropdownBlock();
    const textBlock = getTextBlock();

    if (!dropdown || !textInput || !dropdownBlock || !textBlock) return;

    clearMessageValidation();

    // ===== Variant不要 =====
    if (!require) {
      dropdownBlock.style.display = 'none';
      textBlock.style.display = 'none';

      dropdown.disabled = true;
      textInput.disabled = true;

      dropdown.required = false;
      textInput.required = false;

      dropdown.value = '';
      textInput.value = '';

      resetMessageCardCode();
      return;
    }

    // ===== Variant必要 =====
    dropdownBlock.style.display = '';
    dropdown.disabled = false;
    dropdown.required = true;

    syncMessageCardCode();

    if (dropdown.value === '印字メッセージカード') {
      textInput.disabled = false;
      textInput.required = true;

      if (!textBlock.classList.contains('is-visible')) {
        showWithFade(textBlock, textInput);
      }
    } else {
      textInput.value = '';
      textInput.disabled = true;
      textInput.required = false;
      textInput.setCustomValidity('');

      if (textBlock.classList.contains('is-visible')) {
        hideWithFade(textBlock);
      } else {
        textBlock.style.display = 'none';
      }
    }
  }

  /* ===== Prestige variant変更イベント ===== */
  document.addEventListener('variant:change', function () {
    syncMessageCardCode();
    updateVisibility();
  });

  /* ===== Dropdown変更 ===== */
  document.addEventListener('change', function (e) {
    if (e.target.name === dropdownName) {
      syncMessageCardCode();
      updateVisibility();
    }
  });

  /* ===== 入力時はエラーだけ消す（ポップアップは出さない） ===== */
  document.addEventListener('input', function (e) {
    if (e.target.name === textName) {
      e.target.setCustomValidity('');
    }
  });

  /* ===== フォーム送信時のみバリデーション ===== */
  document.addEventListener(
    'submit',
    function (e) {
      const form = getForm();
      if (!form || e.target !== form) return;

      const isValid = validateMessageOnSubmit();

      if (!isValid) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        const textInput = getTextInput();
        if (textInput) {
          textInput.reportValidity();
        }
      }
    },
    true
  );

  /* ===== cart-drawer更新時の再評価 ===== */
  document.addEventListener('cart-drawer:refreshed', function () {
    setTimeout(function () {
      const dropdown = getDropdown();
      const textInput = getTextInput();
      const dropdownBlock = getDropdownBlock();
      const textBlock = getTextBlock();

      if (!dropdown || !textInput || !dropdownBlock || !textBlock) return;

      dropdown.disabled = false;
      textInput.disabled = false;

      syncMessageCardCode();
      updateVisibility();
    }, 50);
  });

  /* ===== 初期実行 ===== */
  syncMessageCardCode();
  updateVisibility();
});

/* =========================================
   Newsletter pop-upの表示制御
========================================= */
document.addEventListener('DOMContentLoaded', function () {
  const popup = document.querySelector(
    'newsletter-popup[data-tasting-popup]'
  );

  if (!popup) return;

  // Popup送信済みなら表示しない
  if (
    localStorage.getItem('tasting_popup_submitted') === 'true'
  ) {
    return;
  }

  // Popupを閉じてから1日以内なら表示しない
  const closedAt = localStorage.getItem(
    'tasting_popup_closed_at'
  );

  if (closedAt) {
    const daysSinceClosed =
      (Date.now() - Number(closedAt)) / 1000 / 60 / 60 / 24;

    if (daysSinceClosed < 1) {
      return;
    }
  }

  const isMobile = window.matchMedia(
    '(max-width: 699px)'
  ).matches;

  let delay;
  let scrollThreshold;

  // ------------------------------
  // Desktop × Home
  // ------------------------------

  if (!isMobile) {
    delay = 10000;
    scrollThreshold = 0.90;
  }

  // ------------------------------
  // Mobile × Home
  // ------------------------------

  if (isMobile) {
    delay = 8000;
    scrollThreshold = 0.90;
  }

  let popupShown = false;

  function openTastingPopup() {
    if (popupShown) return;

    popupShown = true;

    popup.setAttribute('apparition-delay', '0');

    popup.removeAttribute('hidden');

    popup.setAttribute('open', '');
  }

  const delayTimer = setTimeout(
    openTastingPopup,
    delay
  );

  window.addEventListener(
    'scroll',
    function () {
      const scrollableHeight =
        document.documentElement.scrollHeight -
        window.innerHeight;

      if (scrollableHeight <= 0) return;

      const scrollPercent =
        window.scrollY / scrollableHeight;

      if (scrollPercent >= scrollThreshold) {
        clearTimeout(delayTimer);

        openTastingPopup();
      }
    },
    { passive: true }
  );

  // Popup送信後は今後表示しない
  document.addEventListener('submit', function (event) {
    const form = event.target;

    const tagInput = form.querySelector(
      'input[name="contact[tags]"]'
    );

    if (
      tagInput &&
      tagInput.value.includes('source_tasting_popup')
    ) {
      localStorage.setItem(
        'tasting_popup_submitted',
        'true'
      );
    }
  });

  // Popupを閉じたら1日間表示しない
  document.addEventListener('click', function (event) {
    const closeButton = event.target.closest(
      'newsletter-popup[data-tasting-popup] dialog-close-button, newsletter-popup[data-tasting-popup] .pop-in__close-button'
    );

    if (closeButton) {
      localStorage.setItem(
        'tasting_popup_closed_at',
        String(Date.now())
      );
    }
  });
});

/* =========================================
   Variant picker：
   存在しない組み合わせの事前自動補正
   + 存在しないOption valueの非表示
========================================= */
(function () {
  const productDataCache = new Map();
  const productRequestCache = new Map();
  const bypassOnce = new WeakSet();

  /*
   * Shopify Product Ajax APIから商品データを取得。
   * 同一商品は1回だけ取得し、その後はキャッシュを使用する。
   */
  function loadProductData(handle) {
    if (!handle) {
      return Promise.reject(
        new Error('Product handle is missing.')
      );
    }

    if (productDataCache.has(handle)) {
      return Promise.resolve(
        productDataCache.get(handle)
      );
    }

    if (productRequestCache.has(handle)) {
      return productRequestCache.get(handle);
    }

    const request = fetch(
      Shopify.routes.root +
        'products/' +
        encodeURIComponent(handle) +
        '.js'
    )
      .then(function (response) {
        if (!response.ok) {
          throw new Error(
            'Failed to load product data: ' +
              response.status
          );
        }

        return response.json();
      })
      .then(function (product) {
        productDataCache.set(
          handle,
          product
        );

        productRequestCache.delete(
          handle
        );

        return product;
      })
      .catch(function (error) {
        productRequestCache.delete(
          handle
        );

        console.error(
          '[Custom variant picker]',
          error
        );

        throw error;
      });

    productRequestCache.set(
      handle,
      request
    );

    return request;
  }

  /*
   * inputに対応するOption valueの表示名を取得する。
   *
   * block / swatch / thumbnail / underline等、
   * Prestigeの各表示形式に対応する。
   */
  function getOptionValueName(
    input,
    picker
  ) {
    if (!input || !picker) {
      return '';
    }

    let label = null;

    if (input.id) {
      label = picker.querySelector(
        'label[for="' +
          CSS.escape(input.id) +
          '"]'
      );
    }

    if (
      !label &&
      input.nextElementSibling?.matches?.(
        'label'
      )
    ) {
      label =
        input.nextElementSibling;
    }

    if (!label) {
      return '';
    }

    /*
     * swatch / thumbnailでは
     * sr-only内にOption value名が入っている。
     */
    const srOnly =
      label.querySelector(
        '.sr-only'
      );

    if (
      srOnly?.textContent.trim()
    ) {
      return srOnly.textContent.trim();
    }

    /*
     * block / underline等では、
     * 文字を持つspanを使用する。
     */
    const spans = Array.from(
      label.querySelectorAll('span')
    );

    const textSpan =
      spans.find(function (span) {
        return (
          span.textContent.trim() !== ''
        );
      });

    if (textSpan) {
      return textSpan.textContent.trim();
    }

    return label.textContent.trim();
  }

  /*
   * inputに対応するlabelを取得する。
   */
  function getLabelForInput(
    input,
    picker
  ) {
    if (!input || !picker) {
      return null;
    }

    if (input.id) {
      const label =
        picker.querySelector(
          'label[for="' +
            CSS.escape(input.id) +
            '"]'
        );

      if (label) {
        return label;
      }
    }

    if (
      input.nextElementSibling?.matches?.(
        'label'
      )
    ) {
      return input.nextElementSibling;
    }

    return null;
  }

  /*
   * 同一Option positionにある
   * 指定Option valueのinputを探す。
   */
  function findInputByValueName(
    picker,
    optionPosition,
    valueName
  ) {
    const inputs = Array.from(
      picker.querySelectorAll(
        'input[data-option-position="' +
          optionPosition +
          '"]'
      )
    );

    return (
      inputs.find(function (input) {
        return (
          getOptionValueName(
            input,
            picker
          ) === valueName
        );
      }) || null
    );
  }

  /*
   * 現在選択されているOption value名を
   * Shopify Variantのoptionsと同じ順序で取得する。
   */
  function getCurrentOptionValues(
    picker,
    optionCount
  ) {
    const values = [];

    for (
      let position = 1;
      position <= optionCount;
      position++
    ) {
      const checkedInput =
        picker.querySelector(
          'input[data-option-position="' +
            position +
            '"]:checked'
        );

      if (!checkedInput) {
        values.push(null);
        continue;
      }

      values.push(
        getOptionValueName(
          checkedInput,
          picker
        )
      );
    }

    return values;
  }

  /*
   * 2つのOption値を比較する。
   */
  function sameValue(a, b) {
    return (
      String(a ?? '').trim() ===
      String(b ?? '').trim()
    );
  }

  /*
   * ユーザーが今変更したOptionを優先して保持しながら、
   * 存在しないCombinationだけを補正する。
   *
   * 例：
   *
   * A / Small
   * ↓ Package Cをクリック
   *
   * C / Small は不存在
   *
   * Cを維持したまま成立するSizeを調査
   * → Largeのみ
   *
   * Prestigeがchangeイベントを処理する前に
   * SizeをLargeへ変更する。
   */
  function correctCombination(
    changedInput,
    picker,
    product
  ) {
    if (
      !changedInput ||
      !picker ||
      !product?.variants?.length
    ) {
      return;
    }

    const optionCount =
      product.options?.length || 0;

    if (!optionCount) {
      return;
    }

    const changedPosition =
      parseInt(
        changedInput.getAttribute(
          'data-option-position'
        ),
        10
      ) - 1;

    if (
      Number.isNaN(
        changedPosition
      ) ||
      changedPosition < 0
    ) {
      return;
    }

    const selectedValues =
      getCurrentOptionValues(
        picker,
        optionCount
      );

    /*
     * 現在のCombinationが実在するなら
     * 何もしない。
     *
     * availableは見ない。
     * 在庫切れでもVariant自体が存在する場合は
     * 自動補正の対象にしない。
     */
    const exactVariantExists =
      product.variants.some(
        function (variant) {
          return variant.options.every(
            function (
              value,
              index
            ) {
              return sameValue(
                value,
                selectedValues[index]
              );
            }
          );
        }
      );

    if (exactVariantExists) {
      return;
    }

    /*
     * 今回ユーザーが明示的に選択したOptionは維持する。
     */
    const changedValue =
      selectedValues[
        changedPosition
      ];

    const variantsWithChangedValue =
      product.variants.filter(
        function (variant) {
          return sameValue(
            variant.options[
              changedPosition
            ],
            changedValue
          );
        }
      );

    if (
      variantsWithChangedValue.length ===
      0
    ) {
      return;
    }

    const corrections = [];

    /*
     * 他のOptionを1つずつ調査する。
     */
    for (
      let position = 0;
      position < optionCount;
      position++
    ) {
      if (
        position ===
        changedPosition
      ) {
        continue;
      }

      const compatibleVariants =
        variantsWithChangedValue.filter(
          function (variant) {
            return selectedValues.every(
              function (
                selectedValue,
                index
              ) {
                if (
                  index ===
                    changedPosition ||
                  index === position
                ) {
                  return true;
                }

                return sameValue(
                  variant.options[
                    index
                  ],
                  selectedValue
                );
              }
            );
          }
        );

      if (
        compatibleVariants.length ===
        0
      ) {
        continue;
      }

      const replacementValues = [
        ...new Set(
          compatibleVariants.map(
            function (variant) {
              return variant.options[
                position
              ];
            }
          )
        )
      ];

      /*
       * 現在値が候補に含まれているなら
       * そのOptionは補正不要。
       */
      if (
        replacementValues.some(
          function (value) {
            return sameValue(
              value,
              selectedValues[
                position
              ]
            );
          }
        )
      ) {
        continue;
      }

      /*
       * 候補が1つだけの場合のみ
       * 自動補正。
       */
      if (
        replacementValues.length ===
        1
      ) {
        corrections.push({
          position:
            position + 1,
          value:
            replacementValues[0]
        });
      }
    }

    /*
     * 安全のため、
     * 自動補正箇所が1つだけのときに限定。
     */
    if (
      corrections.length !==
      1
    ) {
      return;
    }

    const correction =
      corrections[0];

    const replacementInput =
      findInputByValueName(
        picker,
        correction.position,
        correction.value
      );

    if (!replacementInput) {
      return;
    }

    /*
     * changeイベントを新しく発火しない。
     *
     * checkedだけ先に変更し、
     * 元々発生しているOption変更イベントを
     * そのままPrestigeへ渡す。
     *
     * これによりAjax再描画は1回だけになる。
     */
    replacementInput.checked =
      true;
  }

  /*
   * 現在の選択Combinationを基準に、
   * 存在しないOption valueだけを非表示にする。
   *
   * Variantのavailableは見ないため、
   * 「存在するがSold Out」のOptionは表示したまま。
   */
  function updateOptionVisibility(
    picker,
    product
  ) {
    if (
      !picker ||
      !product?.variants?.length
    ) {
      return;
    }

    const optionCount =
      product.options?.length || 0;

    if (!optionCount) {
      return;
    }

    const selectedValues =
      getCurrentOptionValues(
        picker,
        optionCount
      );

    for (
      let position = 0;
      position < optionCount;
      position++
    ) {
      const inputs = Array.from(
        picker.querySelectorAll(
          'input[data-option-position="' +
            (position + 1) +
            '"]'
        )
      );

      inputs.forEach(
        function (input) {
          const candidateValue =
            getOptionValueName(
              input,
              picker
            );

          if (
            !candidateValue
          ) {
            return;
          }

          /*
           * 現在の他Optionは維持し、
           * このOptionだけcandidateValueへ
           * 変更したCombinationが存在するか確認。
           */
          const candidateCombination =
            selectedValues.slice();

          candidateCombination[
            position
          ] = candidateValue;

          const variantExists =
            product.variants.some(
              function (variant) {
                return variant.options.every(
                  function (
                    value,
                    index
                  ) {
                    return sameValue(
                      value,
                      candidateCombination[
                        index
                      ]
                    );
                  }
                );
              }
            );

          const label =
            getLabelForInput(
              input,
              picker
            );

          /*
           * inputはPrestige内部処理用に残し、
           * 見た目のlabelだけを非表示にする。
           */
          if (label) {
            label.hidden =
              !variantExists;
          }
        }
      );
    }
  }

  /*
   * Prestige再描画後に、
   * 最新のVariant pickerを取得して
   * Option表示を更新する。
   */
  function scheduleOptionVisibilityUpdate(
    picker
  ) {
    if (!picker) {
      return;
    }

    const handle =
      picker.getAttribute(
        'handle'
      );

    const formId =
      picker.getAttribute(
        'form-id'
      );

    if (
      !handle ||
      !formId
    ) {
      return;
    }

    requestAnimationFrame(
      function () {
        requestAnimationFrame(
          function () {
            /*
             * Prestigeの再描画で
             * picker自体が差し替わっている可能性があるため、
             * 最新のpickerを取得し直す。
             */
            const currentPicker =
              document.querySelector(
                'variant-picker[form-id="' +
                  CSS.escape(
                    formId
                  ) +
                  '"]'
              );

            if (
              !currentPicker
            ) {
              return;
            }

            const product =
              productDataCache.get(
                handle
              );

            if (product) {
              updateOptionVisibility(
                currentPicker,
                product
              );

              return;
            }

            loadProductData(
              handle
            )
              .then(
                function (
                  loadedProduct
                ) {
                  updateOptionVisibility(
                    currentPicker,
                    loadedProduct
                  );
                }
              )
              .catch(
                function () {
                  /*
                   * API取得失敗時は
                   * Prestige標準表示を維持。
                   */
                }
              );
          }
        );
      }
    );
  }

  /*
   * Prestigeより先に処理するため
   * capture phaseで監視。
   */
  document.addEventListener(
    'change',
    function (event) {
      const input =
        event.target;

      if (
        !(
          input instanceof
          HTMLInputElement
        ) ||
        !input.matches(
          'variant-picker input[data-option-position]'
        )
      ) {
        return;
      }

      /*
       * Product API取得失敗時に
       * 再発火したイベントは通常処理へ通す。
       */
      if (
        bypassOnce.has(
          input
        )
      ) {
        bypassOnce.delete(
          input
        );

        return;
      }

      const picker =
        input.closest(
          'variant-picker'
        );

      if (!picker) {
        return;
      }

      const handle =
        picker.getAttribute(
          'handle'
        );

      if (!handle) {
        return;
      }

      /*
       * 通常はページ表示時にpreload済みなので、
       * この時点では同期的に補正できる。
       */
      const cachedProduct =
        productDataCache.get(
          handle
        );

      if (cachedProduct) {
        correctCombination(
          input,
          picker,
          cachedProduct
        );

        /*
         * 何もstopしない。
         * このままPrestige標準change処理へ渡す。
         */
        return;
      }

      /*
       * ユーザー操作がProduct API取得より早かった場合。
       *
       * Prestigeへの元イベントだけ一度止め、
       * データ取得後に同じイベントを再発火する。
       */
      event.stopImmediatePropagation();

      loadProductData(
        handle
      )
        .then(
          function (product) {
            correctCombination(
              input,
              picker,
              product
            );

            input.dispatchEvent(
              new Event(
                'change',
                {
                  bubbles: true
                }
              )
            );
          }
        )
        .catch(
          function () {
            /*
             * API取得に失敗した場合は
             * 自動補正せずPrestige標準動作へ戻す。
             */
            bypassOnce.add(
              input
            );

            input.dispatchEvent(
              new Event(
                'change',
                {
                  bubbles: true
                }
              )
            );
          }
        );
    },
    true
  );

  /*
   * 正常なVariant変更が完了したら、
   * 現在Combinationに存在しない
   * Option valueを非表示にする。
   */
  document.addEventListener(
    'variant:change',
    function (event) {
      const formId =
        event.detail?.formId;

      if (!formId) {
        return;
      }

      const picker =
        document.querySelector(
          'variant-picker[form-id="' +
            CSS.escape(
              formId
            ) +
            '"]'
        );

      if (!picker) {
        return;
      }

      scheduleOptionVisibilityUpdate(
        picker
      );
    }
  );

  /*
   * Product APIを先読みする。
   */
  function preloadPicker(
    picker
  ) {
    const handle =
      picker.getAttribute(
        'handle'
      );

    if (!handle) {
      return;
    }

    loadProductData(
      handle
    )
      .then(
        function (product) {
          /*
           * 初期表示時にも
           * 不存在Optionを非表示。
           */
          updateOptionVisibility(
            picker,
            product
          );
        }
      )
      .catch(
        function () {
          /*
           * 失敗時は実操作時に再試行する。
           */
        }
      );
  }

  function preloadAllPickers(
    root
  ) {
    const scope =
      root || document;

    if (
      scope instanceof
        Element &&
      scope.matches(
        'variant-picker'
      )
    ) {
      preloadPicker(
        scope
      );
    }

    scope
      .querySelectorAll?.(
        'variant-picker'
      )
      .forEach(
        preloadPicker
      );
  }

  /*
   * 初期表示
   */
  preloadAllPickers(
    document
  );

  /*
   * Quick Buy等で後から追加された
   * Variant pickerについても
   * Product APIを先読みし、
   * 不存在Optionを非表示にする。
   */
  const preloadObserver =
    new MutationObserver(
      function (mutations) {
        mutations.forEach(
          function (mutation) {
            mutation.addedNodes.forEach(
              function (node) {
                if (
                  node instanceof
                  Element
                ) {
                  preloadAllPickers(
                    node
                  );
                }
              }
            );
          }
        );
      }
    );

  preloadObserver.observe(
    document.body,
    {
      childList: true,
      subtree: true
    }
  );
})();